import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'ngx-form-module',
  templateUrl: './form-module.component.html',
  styleUrls: ['./form-module.component.scss'],
})
export class FormModuleComponent implements OnInit {

  @Input() title: string;
  @Input() secondTitle: string;
  @Input() value: boolean;
  @Input() secondValue: boolean;
  @Input() disabled: boolean = false;
  @Output() valueChange: EventEmitter<boolean>;
  @Output() secondValueChange: EventEmitter<boolean>;

  constructor() {

    this.valueChange = new EventEmitter<boolean>();
    this.secondValueChange = new EventEmitter<boolean>();
  }

  ngOnInit() {
  }

  updateValue(event) {

    this.valueChange.emit(event);
  }

  updateSecondValue(event) {

    this.secondValueChange.emit(event);
  }

}
